import React, { useState, useEffect, useContext } from "react"
import MaintitleDescforRoute from "../components/MaintitleDesc"
import Layout from "../components/LayoutV2"
import { GlobalContext } from "../functions"
import { getFlightDataWithToken, getHotelsData, getStationsDetails, getTemplatedMeta, nextWeekSameDate } from "../utils/function"
import moment from "moment"
import _ from "lodash"
import * as Fn from "../functions"
import locationsData from "../data/location"
import FlightCardsSection, { HotelsCardsSection } from "../components/FlightCardsSection"
import TabbedLinks from "../components/TabbedLinks"
import FaqAccordion from "../components/FaqAccordion"
import InfoCardsSection from "../components/InfoCardsSection"
import baggage from "../images/baggage.svg";
import baggage2 from "../images/baggage2.svg";
import rewardsIcon from "../images/airasiaRewards.svg";
import baggage50K from "../images/baggage50K.svg";
import fastPass from "../images/fastPass.svg";
import premiumFlex from "../images/premiumFlex.svg";
import xpressBaggage from "../images/xpressBaggage.svg";
import xtraCarry from "../images/xtraCarry.svg";
import clouds from "../images/clouds.svg";
import flight_takeoff from "../images/flight_takeoff.svg";
import currency from "../images/currency.svg";
import currency_exchange from "../images/currency_exchange.svg";
import 'react-loading-skeleton/dist/skeleton.css'
import { getCookie } from "@airasia/phoenix-widgets/widgets/FlightSearchWidget/utils"
import AlternateRouteCard from "../components/AlternateRouteCard"

const flightDataKeys = {
  'paired': {
    flightsList: "searchResults.trips[0].flightsList",
    searchResults: "searchResults",
    content: "content",
    airlineProfile: "pairedFlights.searchResults.trips[0].airlineProfile",
    carriers: "searchResults.carriers",
    segments: "flightDetails?.segments[0]",
    airline: "flightDetails?.segments[0]?.airline",
    marketingFlightNo: "flightDetails?.segments[0]?.marketingFlightNo",
  },
  'bundled': {
    flightsList: "searchResults.trips",
    searchResults: "searchResults",
    content: "content",
    airlineProfile: "searchResults.trips[0].airlineProfile",
    carriers: "searchResults.carriers",
    segments: "flightDetails?.depart?.segments[0]?",
    airline: "flightDetails?.depart.segments[0]?.airline",
    marketingFlightNo: "flightDetails?.depart.segments[0]?.marketingFlightNo",

  }
};

const alternateRoutePairings = {
  DMK: { stationCode: 'BKK', stationName: 'Bangkok - Suvarnabhumi' },
  BKK: { stationCode: 'DMK', stationName: 'Bangkok - Don Mueang' },
  HND: { stationCode: 'NRT', stationName: 'Tokyo - Narita' },
  NRT: { stationCode: 'HND', stationName: 'Tokyo - Haneda' }
};

const alternateRouteSectionRenderer = (routeStr, lang, getLink) => {
  if (lang !== 'en-gb') {
    return;
  }
  let [origin, destination] = routeStr.split('-').map(x => x.trim());
  let isOriginKUL = routeStr.startsWith('KUL');
  let isEligibleDestination = ['DMK', 'BKK', 'NRT', 'HND'].includes(destination);
  if (isOriginKUL && isEligibleDestination) {
    return (
      <AlternateRouteCard  {...alternateRoutePairings[destination]} handleClick={() => {
        Fn.fireGtmEvent({
          'event': 'trackEventNoEcommerce',
          'eventDetails.category': 'SEO|Fligts|Route heatmap',
          'eventDetails.action': 'click',
          'eventDetails.label': 'alternate route card'
        });

        if (typeof window !== "undefined") {
          let a = document.createElement("a");
          a.href = getLink(alternateRoutePairings[destination]['stationCode']);
          a.click()
        }

        // https://www.airasia.com/flights/search/?origin=CEB&destination=PPS&departDate=14/11/2023&tripType=O&adult=1&child=0&infant=0&locale=en-gb&currency=MYR&airlineProfile=k,g&type=paired&cabinClass=economy&uce=true



      }} />
    )
  }
};

const Route = props => {
  // console.log("props from Route ---- ", props)
  var Data = props.pageContext.data
  const stationsDataFromContext = _.get(props, "pageContext.stationsData", {})
  const lang = _.get(props, "pageContext.lang", "en-gb");
  var routeFromTo = Data.routes.split(" to ")
  if (routeFromTo.length < 2) {
    routeFromTo = Data.routes.split(" - ")
  }

  // console.log("Data from page --- ", Data);

  var [CardData, SetCardData] = useState([])
  var [CheapData, SetCheapData] = useState([])
  var [AddCheapData, SetAddCheapData] = useState([])
  var [Retry, SetRetry] = useState(false)
  var [RetryAddCheapData, SetRetryAddCheapData] = useState(false)
  var [StationCode, SetStationCode] = useState([])
  var [LinkData, SetLinkData] = useState([])
  var [OriginStationCode, SetOriginStationCode] = useState([])
  var [RegName, SetRegName] = useState(null)
  var [OriginCountry, SetOriginCountry] = useState(null)
  var [DestinationCountry, SetDestinationCountry] = useState(null)
  var [routes] = useState(() => {
    let u = props?.pageContext?.data?.URL || "";
    let orgArray = u?.split("-to-")?.[0]?.split("/from-")?.[1]?.split("-");
    let destArray = u?.split("-to-")?.[1]?.split("-");
    // orgArray?.pop();
    // destArray?.pop();
    return { origin: (orgArray || []).map(x => _.capitalize(x)).join(" "), destination: (destArray || []).map(x => _.capitalize(x)).join(" ") };
  })
  var curr = useContext(GlobalContext)
  //Ads
  var [width, Setwidth] = useState()
  var [InterprojectInternalLinkingData, setInterprojectInternalLinkingData] = useState([])
  //end ads


  var [GlobalState, setGlobalState] = useState(() => {
    if (typeof (window) !== "undefined") {
      return {
        currency: getCookie("uhfCurrency") || localStorage.getItem("userSelectedCurrency") || "",
        lang: "en/gb"
      };
    }
  })

  useEffect(() => {
    if (typeof (window) !== "undefined") {
      setGlobalState({
        currency: getCookie("uhfCurrency") || localStorage.getItem("userSelectedCurrency") || "",
        lang: "en/gb"
      });
    }
  }, [])

  // useEffect(() => {
  //   console.log("changing changing")
  //   if(typeof(window) !== "undefined"){
  //     localStorage.setItem("userSelectedCurrency", GlobalState?.currency ?? "MYR")
  //   }
  // }, [GlobalState?.currency])

  var [org, dest] = Data.routes.includes("to")
    ? Data.routes.split(" to ")
    : Data.routes.split(" - ")
  useEffect(() => Fn.DynamicWidth(Setwidth), [GlobalState])
  useEffect(() => {
    console.log("dfpslot -- globalstate -- lang", lang)
    Fn.useDfpSlot(
      width,
      lang.split("-")[0],
      org.toLowerCase(),
      dest ? dest.toLowerCase() : null
    )
  }, [width]);

  useEffect(() => {
    fetch(`https://sch.apiairasia.com/seohierarchy/en-gb/file.json`)
      .then(response => response.json())
      .then(data => {
        var result = data
        var destCode = routeFromTo[routeFromTo.length - 1]
        var originCode = routeFromTo[0]
          .toString()
          .toUpperCase()
        if (data.length > 1) {
          SetStationCode(
            result
              .map((x, index) => {
                return {
                  ParentRegionId: x.ParentRegionId,
                  RegionId: x.RegionId,
                  RegionName: x.RegionName,
                  RegionNameAbbr: x.RegionNameAbbr,
                  RegionType: x.RegionType,
                }
              })
              .filter(
                x =>
                  x != null &&
                  x.RegionNameAbbr == destCode &&
                  x.RegionType == "City"
              )
          );
          SetOriginStationCode(
            result
              .map((x, index) => {
                return {
                  ParentRegionId: x.ParentRegionId,
                  RegionId: x.RegionId,
                  RegionName: x.RegionName,
                  RegionNameAbbr: x.RegionNameAbbr,
                  RegionType: x.RegionType,
                }
              })
              .filter(
                x =>
                  x != null &&
                  x.RegionNameAbbr == originCode &&
                  x.RegionType == "City"
              )
          );
          if (StationCode.length > 0) {
            var RegionName = StationCode[0].RegionName
            if (RegionName) {
              SetRegName(StationCode[0].RegionName)
              //console.log("RegName:", RegName)
              GetDatafromAPI(RegionName.toString())
            }
          } else SetRetry(true)
        }
      })
  }, [GlobalState, Retry])
  function GetDatafromAPI(RegName) {
    var title = Data.hero.title.toString().replace("Flights", "")
    title = title.split(" to ")
    const getValue = ({ price }) => +price.slice(1) || 0;
    var today = moment().format("YYYY-MM-DD")
    fetch(
      `https://k.apiairasia.com/availabledates/api/v1/pricecalendar/0/0/${GlobalState.currency
      }/${routeFromTo[0]}/${routeFromTo[routeFromTo.length - 1]}/${today}/1/6`
    )
      .then(response => response.json())
      .then(data => {
        var getCurrency = Object.entries(data)[0][0]
        curr = getCurrency.split("|")
        var result = Object.entries(Object.entries(data)[0][1])
        var day = parseInt(moment(new Date()).format("D"))
        if (result.length > 1 && curr[1]) {
          SetCheapData(
            result
              .map((x, index) => {
                return {
                  departurecode: routeFromTo[0].toString().toUpperCase(),
                  destinationcode: routeFromTo[routeFromTo.length - 1]
                    .toString()
                    .toUpperCase(),
                  month: moment(x[0]).format("MMM"),
                  year: moment(x[0]).format("YYYY"),
                  currency: curr[1],
                  price: x[1],
                }
              })
              .filter(x => x != null));
          AddCheapDatafromAPI(RegName)
          SetCardData(
            result
              .slice(day, day + 5)
              .map((x, index) => {
                return {
                  departure: title[0],
                  destination: title[1],
                  departurecode: routeFromTo[0].toString().toUpperCase(),
                  destinationcode: routeFromTo[routeFromTo.length - 1]
                    .toString()
                    .toUpperCase(),
                  date: moment(x[0]).format("MMMM D, YYYY"),
                  currency: curr[1],
                  price: x[1],
                  image: RegName
                    ? RegName.toLowerCase()
                      .trim()
                      .replace(" ", "-") +
                    "_region_" +
                    (index + 1) +
                    ".jpg"
                    : "bangkok_region_6.jpg",
                }
              })
              .filter(x => x != null)
          )
        }
        if (CardData.length == 0) {
          //if(CardData.length==0||Data.length==0){
          SetRetry(true)
        }
      })
  }
  function AddCheapDatafromAPI(RegName) {
    var title = Data.hero.title.toString().replace("Flights", "")
    title = title.split(" to ")
    const getValue = ({ price }) => +price.slice(1) || 0;
    const currentTime = moment();
    const Next6MonthsfromToday = currentTime.add(6, 'M').format("YYYY-MM-DD");

    fetch(
      `https://k.apiairasia.com/availabledates/api/v1/pricecalendar/0/0/${GlobalState.currency
      }/${routeFromTo[0]}/${routeFromTo[routeFromTo.length - 1]}/${Next6MonthsfromToday}/1/5`
    )
      .then(response => response.json())
      .then(data => {
        var getCurrency = Object.entries(data)[0][0]
        curr = getCurrency.split("|")
        var result = Object.entries(Object.entries(data)[0][1])
        if (result.length > 1 && curr[1]) {
          SetAddCheapData(
            result
              .map((x, index) => {
                return {
                  departurecode: routeFromTo[0].toString().toUpperCase(),
                  destinationcode: routeFromTo[routeFromTo.length - 1]
                    .toString()
                    .toUpperCase(),
                  month: moment(x[0]).format("MMM"),
                  year: moment(x[0]).format("YYYY"),
                  currency: curr[1],
                  price: x[1],
                }
              })
              .filter(x => x != null));
        }
        if (AddCheapData.length == 0) {
          SetRetryAddCheapData(true)
        }
      })
  }
  // var FlightsCards = Data.flights.map((x, index) => (
  //   <LinkBlock key={"routeFlight" + index} {...x} />
  // ))
  if (AddCheapData.length) {
    CheapData = CheapData.concat(AddCheapData)
  }
  useEffect(() => {
    //to get cross project internal linking
    if (StationCode.length && OriginStationCode.length) {
      var getOriginLocationDetail = locationsData.filter(x => x != null && x.name.toLowerCase() === OriginStationCode[0].RegionName.toLowerCase())
      var getDestinationLocationDetail = locationsData.filter(x => x != null && x.name.toLowerCase() === StationCode[0].RegionName.toLowerCase())
      let type
      console.log("StationCode.length", StationCode.length)

      if (getOriginLocationDetail.length > 1) {
        var getState = getOriginLocationDetail.filter(x => x !== null && x.type.toLowerCase() === "state")
        if (getState) getOriginLocationDetail = getState
        else getOriginLocationDetail = getOriginLocationDetail.filter(x => x !== null && x.type.toLowerCase() === "city")
        type = getOriginLocationDetail.map(a => a.type).toString();
      }
      else type = getOriginLocationDetail.map(a => a.type).toString();

      if (getDestinationLocationDetail.length > 1) {
        var getState = getDestinationLocationDetail.filter(x => x !== null && x.type.toLowerCase() === "state")
        if (getState) getDestinationLocationDetail = getState
        else getDestinationLocationDetail = getDestinationLocationDetail.filter(x => x !== null && x.type.toLowerCase() === "city")
        type = getDestinationLocationDetail.map(a => a.type).toString();
        getDestinationLocationDetail = getDestinationLocationDetail.filter(x => x !== null && x.type.toLowerCase() === "city")
      }
      else type = getDestinationLocationDetail.map(a => a.type).toString();

      let originName = OriginStationCode[0].RegionName.replace(" ", "-").toLowerCase()
      let destinationName = StationCode[0].RegionName.replace(" ", "-").toLowerCase()
      let OriginHotelsInternalLinking = null
      let DestinationHotelsInternalLinking = null

      if (type) {
        let OriginCountryName = getOriginLocationDetail.map(a => a.countryName).toString();
        SetOriginCountry(OriginCountryName)
        let OriginStateName = getOriginLocationDetail.map(a => a.stateName).toString();
        let DestCountryName = getDestinationLocationDetail.map(a => a.countryName).toString();
        SetDestinationCountry(DestCountryName)
        let DestStateName = getDestinationLocationDetail.map(a => a.stateName).toString();
        if (type == "city") {
          OriginHotelsInternalLinking = `https://www.airasia.com/all-hotels/${OriginCountryName.replace(" ", "-").toLowerCase()}/${OriginStateName.replace(" ", "-").toLowerCase()}/${originName}/`
          DestinationHotelsInternalLinking = `https://www.airasia.com/all-hotels/${DestCountryName.replace(" ", "-").toLowerCase()}/${DestStateName.replace(" ", "-").toLowerCase()}/${destinationName}/`
        }
        if (type == "country") {
          OriginHotelsInternalLinking = `https://www.airasia.com/all-hotels/${OriginCountryName.replace(" ", "-").toLowerCase()}/`
          DestinationHotelsInternalLinking = `https://www.airasia.com/all-hotels/${DestCountryName.replace(" ", "-").toLowerCase()}/`
        }
        if (type == "state") {
          OriginHotelsInternalLinking = `https://www.airasia.com/all-hotels/${OriginCountryName.replace(" ", "-").toLowerCase()}/${OriginStateName.replace(" ", "-").toLowerCase()}/`
          DestinationHotelsInternalLinking = `https://www.airasia.com/all-hotels/${DestCountryName.replace(" ", "-").toLowerCase()}/${DestStateName.replace(" ", "-").toLowerCase()}/`
        }

        fetchTheUrl(OriginHotelsInternalLinking, OriginStationCode[0].RegionName)
        // fetchTheUrl(DestinationHotelsInternalLinking, StationCode[0].RegionName) 

        if (LinkData.length) {
          let filterData = LinkData.filter((v, i, a) => a.findIndex(t => (t.title === v.title)) === i)
          var Data = [{
            title: `More to explore for ${OriginStationCode[0].RegionName} & ${StationCode[0].RegionName}`,
            description: "",
            link: [...filterData]
          }]
          setInterprojectInternalLinkingData(Data)

        }
      }
    }
  }, [OriginStationCode])

  function fetchTheUrl(URL, Location) {
    fetch(URL)
      .then((response) => {
        if (response.status == 200) {
          var data =
          {
            title: `Hotels in ${Location}`,
            href: URL
          }
          var promotion = {
            title: "Promotions",
            href: "https://www.airasia.com/promotions/"
          }
          LinkData.push(data)
          LinkData.push(promotion)

        }
        else {
          var data =
          {
            title: "Promotions",
            href: "https://www.airasia.com/promotions/"
          }

          LinkData.push(data)
        }
        response.json()
      })
      .then((findresponse) => {
        //console.log("findresponse.url",findresponse)
      })

  }

  const [flightsData, setFlightsData] = useState({});
  const [isLoadingFlightsData, setIsLoadingFlightsData] = useState(true);

  const flightsDataFxn = async () => {
    setIsLoadingFlightsData(true);
    let tempFlightData = await getFlightDataWithToken(Data, _.get(GlobalState, "currency", "MYR"), lang, _.get(props, 'pageContext.isAaRoute', false));
    setFlightsData(tempFlightData);
    setIsLoadingFlightsData(false);
  };

  const [hotelsData, setHotelsData] = useState([]);
  const [isLoadingHotelsData, setIsLoadingHotelsData] = useState(true);

  const hotelsDataFxn = async () => {
    setIsLoadingHotelsData(true);
    let currencyForApi = _.get(GlobalState, "currency", "MYR");
    let tempHotelsData = await getHotelsData(Data, _.isEmpty(currencyForApi) ? 'MYR' : currencyForApi, lang);
    setHotelsData(tempHotelsData);
    setIsLoadingHotelsData(false);
  };

  const [stationsData, setStationsData] = useState({});

  const stationsDataFxn = async () => {
    let tempStations = await getStationsDetails(lang, org, dest);
    setStationsData(tempStations);
  };

  useEffect(() => {
    stationsDataFxn();
    flightsDataFxn();
    hotelsDataFxn();

  }, [GlobalState?.currency]);

  const viewMoreFlightsLink = `https://www.airasia.com/flights/search/?origin=${org}&destination=${dest}&departDate=${nextWeekSameDate()}&tripType=O&adult=1&child=0&infant=0&locale=${lang}&currency=${_.get(GlobalState, "currency", "MYR")}&airlineProfile=all&type=paired&cabinClass=economy&uce=true`;
  const getAlternateRouteFlightsLink = (alternateDestCode) => `https://www.airasia.com/flights/search/?origin=${org}&destination=${alternateDestCode}&departDate=${nextWeekSameDate()}&tripType=O&adult=1&child=0&infant=0&locale=${lang}&currency=${_.get(GlobalState, "currency", "MYR")}&airlineProfile=k,g&type=paired&cabinClass=economy&uce=true`
  const selectFlightLink = `https://www.airasia.com/flights/checkout/${lang.replace("-", "/")}/${_.get(GlobalState, "currency", "MYR")}/{tripId}`;


  const metaOverrides = getTemplatedMeta('route', lang, { origin: _.get(stationsDataFromContext, 'orgStationData.StationName'), origin_code: _.get(stationsDataFromContext, 'orgStationData.StationCode'), destination: _.get(stationsDataFromContext, 'destStationData.StationName'), destination_code: _.get(stationsDataFromContext, 'destStationData.StationCode') })

  return (
    <Fn.GlobalContext.Provider
      value={{ state: GlobalState, updateState: setGlobalState }}
    >
      <Layout
        /* api={props.pageContext.api} */
        breadCrumbs={Data.breadcrumbs}
        routes={Data.routes}
        hero={Data.hero}
        heroImages={_.get(Data, 'hero_images', {})}
        meta={Data.meta}
        url={Data.URL}
        lang={lang}
        head={Data.head}
        currency={_.get(GlobalState, "currency", "")}
        template='route'
        overrides={metaOverrides}
        isMOVE={_.get(Data, 'isMOVE', false)}
      >
        {/* <SnapListingWidgetWrapper route={Data.routes} /> */}
        {/* {DestinationCountry && OriginCountry?
        (OriginCountry.toLowerCase() !== "india" && DestinationCountry.toLowerCase() !== "india" ?
        <SnapListingWidgetWrapper route={routeFromTo} />:null):null} */}
        {/* {CheapData ? <FareGraph data={CheapData} routes={Data.routes} />:null} */}

        {/* <ExpandableContent {...Data.cheap_flights} /> */}

        {/* {CardData ? <FlightDealsCards data={CardData} /> : null} */}

        {/* {[
          FlightsCards[0],
          <div id="div-gpt-ad-1586342250790-0"></div>,
          ...FlightsCards.splice(1),
        ]} */}


        {/*  {
          isLoadingFlightsData
            ?
            <div style={{display: "flex", flexDirection: "column", gap: 16, }}>
              <Skeleton  height={48} width={500}/>
              <Skeleton height={16} width={400} />
              <div style={{display: "flex", gap: 28}}>
                <div style={{display: "flex", width: "100%", height: 250}}>
                  <Skeleton height={250} containerClassName="skeletonContainerClass" />
                </div>
                <div style={{display: "flex", width: "100%", height: 250}}>
                  <Skeleton height={250} containerClassName="skeletonContainerClass" />
                </div>
                <div style={{display: "flex", width: "100%", height: 250}}>
                  <Skeleton height={250} containerClassName="skeletonContainerClass" />
                </div>
              </div>
            </div>
            :
            <>
              
            </>
        } */}

        <MaintitleDescforRoute {...(_.get(Data, "hero_content"))} description={_.replace(_.get(Data, "hero_content.description", "") || "", /(style=")[\w\d\s;:-]*"/gi, "")} keywords={{ cheapest_price: _.get(flightsData, "cheapestPrice", "-"), list_of_available_airlines: _.get(flightsData, "list_of_airlines", []).join(", "), flight_duration: _.get(flightsData, "flight_duration", "-") }} />

        <FlightCardsSection
          viewMoreFlightsLink={viewMoreFlightsLink}
          selectFlightLink={selectFlightLink}
          width={width}
          flightDataKeys={flightDataKeys}
          searchType={flightsData?.searchType || 'bundled'}
          sortBy="cheapest"
          isLoading={isLoadingFlightsData}
          title={_.get(Data, "cheap_flights.title", "Cheapest Flights")}
          subTitle={_.get(Data, "cheap_flights.description", "Find the cheapest flight options")}
          // tabTitles={[_.get(flightsData, 'dates.inThreeMonths', 'In Three Months'), _.get(flightsData, 'dates.nextMonth', 'Next Month'), _.get(flightsData, 'dates.nextWeek', 'Next Week')]}
          tabTitles={_.get(flightCardsTabTitles, lang, flightCardsTabTitles['en-gb'])}
          data={[flightsData?.wholeDataOfInThreeMonths, flightsData?.wholeDataOfMonth, flightsData?.wholeDataOfWeek]}
        />

        {alternateRouteSectionRenderer(Data.routes, lang, getAlternateRouteFlightsLink)}

        {/* <FlightCardsSection viewMoreFlightsLink={viewMoreFlightsLink} selectFlightLink={selectFlightLink} width={width} flightDataKeys={flightDataKeys} searchType={flightsData?.searchType || 'bundled'} sortBy="direct" isLoading={isLoadingFlightsData} noTab title={_.get(Data, "cheapest_flights_non_stop.title", "Cheapest Direct Flights")} subTitle={_.get(Data, "cheapest_flights_non_stop.description", "Find the cheapest direct flight options")} data={flightsData?.wholeDataOfMonth} /> */}
        {/* <LazyLoad height={100} offset={300}> */}
        <div
          id="div-gpt-ad-1586342250790-0"
          style={{ marginBottom: "1rem" }}
        ></div>
        {/* </LazyLoad> */}
        <FlightCardsSection viewMoreFlightsLink={viewMoreFlightsLink} selectFlightLink={selectFlightLink} width={width} flightDataKeys={flightDataKeys} searchType={flightsData?.searchType || 'bundled'} sortBy="fastest" isLoading={isLoadingFlightsData} title={_.get(Data, "all_flights_to_destination.title", "Reach Sooner!")} subTitle1={_.get(Data, "all_flights_to_destination.description", "Find the shortest flight duration options")} noTab data={flightsData?.wholeDataOfWeek} />

        <InfoCardsSection title={_.get(Data, "services_and_facilities.title", "Services & Facilities")}
          subTitle={_.get(Data, "services_and_facilities.description", ` `)} data={formInfoCardsData(_.get(Data, "services_and_facilities"), getInfoCardsByLanguage(lang))} isMasonStyle />

        <HotelsCardsSection title={getHotelSectionTitle(lang, _.get(stationsData, "destStation.StationName"))} data={hotelsData} width={width} />
        {/* <InfoCardsSection title={_.get(Data, "destination_information.title", "Destination information")} 
        // subTitle={`check flights from  ${routes.origin} to other destinations`}
        >
          {destinationInfoCardsData.map((data, idx)=><InfoCard data={Data} isSmall key={`dest_info_card_${idx}`} {...data} />)}
        </InfoCardsSection> */}
        {/* <HotelsCarousel title={`Hotels around ${routes.destination}`} subTitle="Looking for the shortest flight duration? here’s is a flight for you" /> */}
        <TabbedLinks data={Data?.popular_flights} />
        <FaqAccordion {..._.get(Data, "faq", {})} keywords={{ cheapest_price: _.get(flightsData, "cheapestPrice", "-"), list_of_available_airlines: _.get(flightsData, "list_of_airlines", []).join(", "), flight_duration: _.get(flightsData, "flight_duration", "-") }} />

        {/* 
        <InfoCardsSection title="See more promotions">
          {extraPromotionsInfoCardsData.map((data, idx)=><InfoCard isSmall key={`promo_info_card_${idx}`} {...data} />)}
        </InfoCardsSection>
        <Title type="h2">Flights from {routes.origin} to {routes.destination}</Title>
        <br />
        <Text >
          A flight from {routes.origin} ({routeFromTo[0]}) to {routes.destination} ({routeFromTo[routeFromTo.length - 1]}) covers a distance of approximately 5,769 km. AirAsia offers FlyThru flights for this route transferring via Kuala Lumpur. Usually, it takes an average flight time of around 9 hours, plus a layover time of 14 to 17 hours — depending on your chosen flight. Jakarta is only 2 hours behind Tokyo, so you will not need to fret about any jet lag! The GMT for Jakarta is +7, whereas Tokyo is +9.
          <br />
          <br />
          Indonesia’s capital Jakarta is the country’s centre of economy, culture and politics. It is one of the most populated cities in the world — home to around 10 million people — and features a melting pot of cultures including Javanese, Malay and Chinese citizens. Located on the northwest coast of Java island, Jakarta is one of the main gateways for tourists to explore the country’s most popular destinations, but it has no shortage of attractions spread across five districts: Ancol Dreamland, Monas, and the Merdeka Palace — just to name a few
        </Text> */}



        {/* {InterprojectInternalLinkingData.map((x,index)=><LinkBlock key={"InterprojectInternalLinkingData"+index} {...x}/>)}  */}

        {/* <InternalLinkingBlock linkObjects={Data.popular_destinations} /> */}

        <MaintitleDescforRoute {...Fn.getDateProperizedContent(Data.route_content, lang)} />
        {/* <LazyLoad height={100} offset={300}> */}
        <div
          id="div-gpt-ad-1586342250790-1"
          style={{ marginBottom: "1rem", marginTop: "1rem" }}
        ></div>
        {/* </LazyLoad> */}
      </Layout>
    </Fn.GlobalContext.Provider>
  )
}
export default Route;

const getHotelSectionTitle = (lang, destination) => {
  let tempTitleTemplate = _.get(hotelSectionTitleMap, lang, _.get(hotelSectionTitleMap, 'en-gb', 'Hotels in '));
  let finalTitle = tempTitleTemplate + destination;
  return finalTitle;
};

const hotelSectionTitleMap = {
  "en-gb": "Hotels in ",
  "id-id": "Hotel di ",
  "th-th": "โรงแรมใน"
};

const extraPromotionsInfoCardsData = [
  {
    imageSrc: null,
    imageAlt: null,
    title: "Find Hotel in Tokyo",
    onClick: () => null
  },
  {
    imageSrc: null,
    imageAlt: null,
    title: "See other promotions",
    onClick: () => null
  }
];

const destinationInfoCardsData = [
  {
    imageSrc: currency,
    imageAlt: "Currency",
    title: "Currency",
    titleKey: "destination_information.information.currency",
    content: {
      main: "Japanese Yen ¥, JP¥",
      helper: null
    }
  },
  {
    imageSrc: currency_exchange,
    imageAlt: "Currency Exchane",
    title: "Today’s exchange rate",
    titleKey: "destination_information.information.exchange_rate",
    content: {
      main: "10.000 IDR = 79,63 JPY",
      helper: null
    }
  },
  {
    imageSrc: clouds,
    imageAlt: "Weather",
    title: "Tokyo weather in January",
    titleKey: "destination_information.information.weather",
    content: {
      main: "2° - 10° C",
      helper: "rain: 3 days"
    }
  },
  {
    imageSrc: flight_takeoff,
    imageAlt: "Flight Take-Off",
    title: "Flight duration",
    titleKey: "destination_information.information.flight_duration",
    content: {
      main: "7h 14m",
      helper: ""
    }
  }
];

const formInfoCardsData = (textData = {}, cardsData = []) => {
  return cardsData.map(card => ({ ...card, title: _.get(textData, `${card["key"]}.title`, _.get(card, 'title', '')), content: _.get(textData, `${card["key"]}.description`, _.get(card, 'content', '')) }))
}

const infoCardsData = [
  {
    imageSrc: baggage,
    imageAlt: "Red Baggage",
    key: "baggage",
    title: "Complimentary Baggage",
    content: "20 kgs Complimentary baggage allowance is defaulted when you make one of the bookings of Value Pack , Premium Flex , or Premium Flatbed."
  },
  {
    imageSrc: baggage2,
    imageAlt: "Yellow Baggage",
    key: "carry_on",
    title: "Carry-On",
    content: "You are allowed to bring onboard two (2) pieces of bag as part of your cabin baggage allowance with the total weight of both items not exceeding 7kg"
  },
  {
    // imageSrc: premiumFlex,
    imageAlt: "Premium Flex",
    key: "premium_flex",
    title: "Premium Flex",
    content: "Provide travel flexibility, 20kg checked baggage, flexibility in choosing seat, Xpress baggage, Xpress boarding, Complimentary inflight meal, Insurance 1 Hour On Time Guarantee and Baggage Delay"
  },
  {
    // imageSrc: rewardsIcon,
    imageAlt: "airasia Rewards",
    key: "big",
    title: "AirAsia BIG",
    content: "Collect points when you fly with AirAsia and exchange with free flights, hotel accommodation, food, insurance, and additional baggage or transfer AirAsia BIG points to other registered members"
  }

]

const infoCardsDataThai = [
  {
    imageSrc: baggage,
    imageAlt: "Red Baggage",
    key: "baggage",
    title: "ฟรี น้ำหนักสัมภาระ",
    content: "ฟรี น้ำหนักกระเป๋า 20 กก. เมื่อซื้อแพ็กสุดคุ้ม Premium Flex หรือ Premium Flatbed"
  },
  {
    imageSrc: baggage2,
    imageAlt: "Yellow Baggage",
    key: "carry_on",
    title: "สัมภาระขึ้นเครื่อง",
    content: "สามารถนำกระเป๋าขึ้นเครื่องได้ 2 ใบ น้ำหนักรวมกันไม่เกิน 7 กก."
  },
  {
    // imageSrc: premiumFlex,
    imageAlt: "Premium Flex",
    key: "premium_flex",
    title: "Premium Flex",
    content: "ให้การเดินทางยืดหยุ่นยิ่งขึ้นกับแพ็กเกจสุดพรีเมี่ยม ฟรี น้ำหนักกระเป๋า 20 กก. พร้อมเลือกที่นั่งได้ตามใจชอบ บริการรับสัมภาระด่วน บริการขึ้นเครื่องด่วน อาหารบนเครื่อง รวมถึงประกันภัยคุ้มครองความล่าช้าของเที่ยวบินและสัมภาระตั้งแต่ 1 ชั่วโมงขึ้นไป"
  },
  {
    // imageSrc: rewardsIcon,
    imageAlt: "airasia Rewards",
    key: "big",
    title: "AirAsia BIG",
    content: "สะสมคะแนน airasia points เมื่อบินกับแอร์เอเชีย ประหยัดเพิ่มขึ้นอีกเมื่อใช้คะแนนซื้อตั๋วเครื่องบิน, ที่พัก, อาหาร, ประกันภัย และอีกมากมาย"
  }

]

const infoCardsDataIndonesian = [
  {
    imageSrc: baggage,
    imageAlt: "Red Baggage",
    key: "baggage",
    title: "Gratis Bagasi",
    content: "Gratis bagasi 20kg setiap pembelian tiket pesawat dengan paket Value Pack, Premium Flex, atau Premium Flatbed."
  },
  {
    imageSrc: baggage2,
    imageAlt: "Yellow Baggage",
    key: "carry_on",
    title: "Bagasi Kabin",
    content: "Anda boleh membawa 2 (dua) barang pribadi yang terdiri atas bagasi kabin dan tas (tas laptop/tas tangan/tas kecil/tas punggung) dengan berat total maksimal 7kg"
  },
  {
    // imageSrc: premiumFlex,
    imageAlt: "Premium Flex",
    key: "premium_flex",
    title: "Premium Flex",
    content: "Premium Flex memberikan keamanan, fleksibilitas untuk mengubah jadwal penerbangan dan memilih kursi tanpa biaya tambahan, gratis bagasi 20kg, Bagasi Xpress, Boarding Xpress, gratis in-flight meal, asuransi jaminan 1 jam tepat waktu dan keterlambatan bagasi."
  },
  {
    // imageSrc: rewardsIcon,
    imageAlt: "airasia Rewards",
    key: "big",
    title: "airasia rewards",
    content: "Kumpulkan poin airasia saat Anda terbang bersama kami dan nikmati penghematan lebih banyak saat Anda menggunakannya untuk pembayaran tiket pesawat, hotel, makanan, asuransi, dan lainnya."
  }

]

const getInfoCardsByLanguage = (language) => {
  if (language.includes("th")) {
    return infoCardsDataThai
  }
  if (language.includes("id")) {
    return infoCardsDataIndonesian
  }
  return infoCardsData
};


const flightCardsTabTitles = [
  {
    'en-gb': ['Recommended', 'Next Month', 'Next Week'],
    'th-th': ['แนะนำ', 'เดือนถัดไป', 'สัปดาห์ถัดไป'],
    'id-id': ['Direkomendasikan', 'Bulan berikutnya', 'Minggu berikutnya'],
    'kh-km': ['បានណែនាំ', 'ខែនេះ', 'ពីរខែមុន'],
    'vi-vn': ['Được khuyến nghị', 'Tháng tiếp theo', 'Tuần tới'],
    'zh-cn': ['推荐', '下个月', '下周'],
    'zh-hk': ['推薦', '下個月', '下週'],
    'zh-tw': ['推薦', '下個月', '下週'],
    'ru-ru': ['Рекомендуется', 'Следующий месяц', 'Следующая неделя'],
    'ja-jp': ['おすすめ', '翌月', '翌週'],
    'ko-kr': ['추천', '다음 달', '다음 주'],
    'tu-tr': ['Önerilen', 'sonraki ay', 'sonraki hafta']
  }
]